export default function playCount(count) {
  return (count == 1 ? 'Play' : 'Plays');
}



// WEBPACK FOOTER //
// ./src/lib/playCount.js